import React from 'react';
import './Text.scss'

const Text = props => {
    const classes = 'Text ' + props.className;

    return (
        <span className={classes}>{props.content}</span>
    );
}


export default Text;
